import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CoreState } from '@rd/core/store/reducers';
import {
  getPageLoadingState,
  getTenantBootstrapFeatureFlags,
  getTenantBootstrapLoyaltyPrograms,
  getTenantBootstrapPaymentProcessingFee,
  getTenantBootstrapRoundingPreference,
} from '@rd/core/tenant/store/selectors/tenant.selectors';
import { LoyaltyProgram, TransferRate } from '@rd/types';
import { PaymentProcessingModel } from '@rd/types/payment-processing.model';
import { RoundingPreferenceModel } from '@rd/types/rounding-preference.model';
import { isNotNull } from '@rd/utils/isNotNull';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TenantFacade {
  constructor(private store: Store<CoreState>) {}

  getRoundingPreferences$: Observable<RoundingPreferenceModel> = this.store
    .select(getTenantBootstrapRoundingPreference)
    .pipe(filter(isNotNull));

  getPaymentProcessingFee$: Observable<PaymentProcessingModel> = this.store
    .select(getTenantBootstrapPaymentProcessingFee)
    .pipe(filter(isNotNull));

  getTenantTransferRate$: Observable<TransferRate> = this.store
    .select(getTenantBootstrapLoyaltyPrograms)
    .pipe(filter(isNotNull))
    .pipe(map(([loyaltyProgram]) => loyaltyProgram.transferRate));

  getTenantFeatureFlags$: Observable<{ [key: string]: boolean }> = this.store
    .select(getTenantBootstrapFeatureFlags)
    .pipe(filter(isNotNull));

  getPageLoadingState$: Observable<boolean> =
    this.store.select(getPageLoadingState);

  getTenantBootstrapLoyaltyProgram$: Observable<LoyaltyProgram> = this.store
    .select(getTenantBootstrapLoyaltyPrograms)
    .pipe(
      filter(isNotNull),
      map(([loyaltyProgram]: LoyaltyProgram[]) => loyaltyProgram),
    );
}
